<template>
<div id="login-box">
    <!-- <Header></Header> -->
    <layout-customs>
    <!-- Page Content -->
    <div class="login-box"> 
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-5 col-sm-5">
                    <div class="login-left">
                        <h3 class="headline-1 login-title">Welcome to<br> Greeneum Energy<br> Platform</h3>
                        <h3 v-show="isSuccessfulRegistration == false" class="headline-3">Registration Form</h3>
                        <div v-if="isSuccessfulRegistration == false" class="signIn signUp">
                            <div class="row">
                                <div class="col-md-12 social-line">
                                  <ul>
                                    <li>
                                      <g-signin-button
                                        class="soc"
                                        :params="googleSignInParams"
                                        @success="signInWithGoogleSuccess"
                                        @error="signInError"
                                      >
                                           <a><i class="fa fa-google-plus-square" aria-hidden="true"></i></a>
                                      </g-signin-button>  

                                      <!-- <a href=""><i class="fa fa-google-plus-square" aria-hidden="true"></i></a> -->
                                    </li>
                                    <li>
                                      <fb-signin-button
                                        class="soc"
                                        :params="fbSignInParams"
                                        @success="signInWithFacebookSuccess"
                                        @error="signInError"
                                      >
                                          <a><i class="fa fa-facebook-square"  aria-hidden="true"></i></a>
                                      </fb-signin-button>
                                      <!-- <a href=""><i class="fa fa-facebook-square"  aria-hidden="true"></i></a> -->

                                      </li>
                                    <li><a @click="liLogin"><i class="fa fa-linkedin-square" aria-hidden="true"></i></a></li>
                                  </ul>
                                </div>
                                <div class="col-xs-12 col-lg-10">
                                    <div>
                                        <input
                                            type="email"
                                            name="email"
                                            v-validate="'required|email'"
                                            v-model="userData.email"
                                            class="form-control"
                                            :class="{'error-input': errors.has('email')}"
                                            placeholder="Email"
                                        >
                                        <span
                                            class="error"
                                            v-if="errors.has('email')"
                                        >{{errors.first('email')}}</span>
                                    </div>
                                    <div>
                                        <input
                                            type="password"
                                            name="password"
                                            autocomplete="new-password"
                                            v-validate="'required|min:8'"
                                            class="form-control"
                                            v-model="userData.password"
                                            placeholder="Password"
                                            :class="{'error-input': errors.has('password')}"
                                        >
                                        <span
                                            class="error"
                                            v-if="errors.has('password')"
                                        >{{errors.first('password')}}</span>
                                    </div>                                    
                                    <div>
                                        <input
                                            type="text"
                                            name="walletAddressGREEN"                                            
                                            v-validate="'required'"
                                            class="form-control"
                                            v-model="userData.walletAddressGREEN"
                                            placeholder="GREEN Wallet Address"
                                            :class="{'error-input': errors.has('walletAddressGREEN')}"
                                        >
                                        <span
                                            class="error"
                                            v-if="errors.has('walletAddressGREEN')"
                                        >{{errors.first('walletAddressGREEN')}}</span>                                                                              
                                        <span
                                            class="error"
                                            v-if="errors.has('walletAddressGREEN')"
                                        >{{errors.first('walletAddressGREEN')}}</span>                                        
                                        <div class="c-info">
                                            <span>GREEN contract address 0xe0a16435df493bd17a58cb2ee58675f5ea069517</span>
                                            <br>  
                                            <a href="https://kb.myetherwallet.com/en/tokens/how-to-add-custom-token/" class="s-lnk">For more information</a>
                                        </div>
                                        <p>
                                            <a href="https://edge.app/" class="s-lnk">Edge</a>
                                            <a href="https://metamask.io/" class="s-lnk">Metamask</a>
                                        </p>
                                    </div>
                  <!--                   <div>
                                        <input
                                            type="text"
                                            name="contractAddressGREEN"
                                            v-validate="'required'"
                                            class="form-control"
                                            v-model="userData.contractAddressGREEN"
                                            placeholder="Contract Address GREEN"
                                            :class="{'error-input': errors.has('contractAddressGREEN')}"
                                        >
                                        <span
                                            class="error"
                                            v-if="errors.has('contractAddressGREEN')"
                                        >{{errors.first('contractAddressGREEN')}}</span>
                                        
                                        <a href="https://edge.app/" class="s-lnk">Edge</a>
                                        <a href="https://metamask.io/" class="s-lnk">Metamask</a>
                                    </div> -->
                                   <!--  <div>
                                        <input
                                            type="text"
                                            name="Name"
                                            v-validate="'required'"
                                            v-model="userData.firstName"
                                            class="form-control"
                                            :class="{'error-input': errors.has('firstName')}"
                                            placeholder="Name"
                                        >
                                        <span
                                            class="error"
                                            v-if="errors.has('firstName')"
                                        >{{errors.first('firstName')}}</span>
                                    </div> -->
                                    <!-- div>
                                        <input
                                            type="text"
                                            name="lastName"
                                            v-validate="'required'"
                                            v-model="userData.lastName"
                                            placeholder="Last Name"
                                            class="form-control"
                                            :class="{'error-input': errors.has('lastName')}"
                                        >
                                        <span
                                            class="error"
                                            v-if="errors.has('lastName')"
                                        >{{errors.first('lastName')}}</span>
                                    </div -->
                                   <!--  <div>
                                        <input
                                            type="text"
                                            name="address"
                                            v-model="userData.address"
                                            v-validate="'required'"
                                            class="form-control"
                                            :class="{'error-input': errors.has('address')}"
                                            placeholder="Address"
                                        >
                                        <span
                                            class="error"
                                            v-if="errors.has('address')"
                                        >{{errors.first('address')}}</span>
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                            name="city"
                                            v-validate="'required'"
                                            v-model="userData.city"
                                            class="form-control"
                                            :class="{'error-input': errors.has('city')}"
                                            placeholder="City"
                                        >
                                        <span
                                            class="error"
                                            v-if="errors.has('city')"
                                        >{{errors.first('city')}}</span>
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                            name="stateProvince"
                                            v-validate="'required'"
                                            v-model="userData.stateProvince"
                                            class="form-control"
                                            :class="{'error-input': errors.has('stateProvince')}"
                                            placeholder="State/Province"
                                        >
                                        <span
                                            class="error"
                                            v-if="errors.has('stateProvince')"
                                        >{{errors.first('stateProvince')}}</span>
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                            name="postalZipCode"
                                            v-validate="'required'"
                                            v-model="userData.postalZipCode"
                                            class="form-control"
                                            :class="{'error-input': errors.has('postalZipCode')}"
                                            placeholder="Postal/ZIP code"
                                        >
                                        <span
                                            class="error"
                                            v-if="errors.has('postalZipCode')"
                                        >{{errors.first('postalZipCode')}}</span>
                                    </div>
                                    <div>
                                        <select
                                                name="country"
                                                v-validate="'required'"
                                                ref="selectCountry"
                                                data-vv-as="Country"
                                                :class="{'error-input': errors.has('country')}"
                                        >
                                            <option
                                                value=""
                                                selected
                                            >Country</option>
                                            <option
                                                v-for="(country, key) in countries"
                                                v-bind:key="key"
                                                :value="country.name"
                                            >{{country.name}}</option>
                                        </select>
                                        <span
                                            class="error"
                                            v-if="errors.has('country')"
                                        >The Country field is requered.</span>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-lg-6">
                                    <div>
                                        <input
                                            type="text"
                                            name="telephone"
                                            v-model="userData.telephone"
                                            v-validate="'phone'"
                                            class="form-control"
                                            :class="{'error-input': errors.has('telephone')}"
                                            placeholder="Telephone"
                                        >
                                        <span
                                            class="error"
                                            v-if="errors.has('telephone')"
                                        >{{errors.first('telephone')}}</span>
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                            name="contactPerson"
                                            v-model="userData.contactPerson"
                                            class="form-control"
                                            :class="{'error-input': errors.has('contactPerson')}"
                                            placeholder="Contact Person"
                                        >
                                        <span
                                            class="error"
                                            v-if="errors.has('contactPerson')"
                                        >{{errors.first('contactPerson')}}</span>
                                    </div>
                                    <div>
                                        <input
                                            type="email"
                                            name="emailContact"
                                            v-validate="'email'"
                                            v-model="userData.emailContact"
                                            class="form-control"
                                            :class="{'error-input': errors.has('emailContact')}"
                                            placeholder="Email Contact"
                                        >
                                        <span
                                            class="error"
                                            v-if="errors.has('emailContact')"
                                        >{{errors.first('emailContact')}}</span>
                                    </div>
                                     -->
<!--                                     <div class="line-margin">
                                        <div class="green-chbx three" v-bind:class="{ active: userData.producer }" v-on:click="userData.producer = !userData.producer; userData.affiliate = false; userData.investor=false;" v-model="typeOfProfile"><div></div></div>
                                        <div class="green-chbx-lable">Energy producer</div>
                                    </div> 
                                    <div class="line-margin">
                                        <div class="green-chbx" v-bind:class="{ active: userData.affiliate }" v-on:click="userData.affiliate = !userData.affiliate; userData.investor=false; userData.producer = false;" v-model="typeOfProfile"><div></div></div>
                                         <div class="green-chbx-lable">I’m representing different projects and organisations and I want to be part of the <span>AFFILIATE PROGRAM</span>.</div>
                                    </div>
                                    <div class="line-margin">
                                        <div class="green-chbx two" v-bind:class="{ active: userData.investor }" v-on:click="userData.investor = !userData.investor; userData.affiliate = false;userData.producer = false;" v-model="typeOfProfile"><div></div></div>
                                        <div class="green-chbx-lable">I want to invest or donate to GREEN projects</div>
                                    </div> -->
                                    <div class="line-margin">
                                        <div class="green-chbx three" v-bind:class="{ active: userData.producer }" v-on:click="userData.producer = !userData.producer; ;" v-model="typeOfProfile"><div></div></div>
                                        <div class="green-chbx-lable">Energy producer</div>
                                    </div> 
                                    <div class="line-margin">
                                        <div class="green-chbx" v-bind:class="{ active: userData.affiliate }" v-on:click="userData.affiliate = !userData.affiliate; " v-model="typeOfProfile"><div></div></div>
                                        <div class="green-chbx-lable">Affiliate</div>                                       
                                    </div>
                                    <div class="line-margin">
                                        <div class="green-chbx two" v-bind:class="{ active: userData.investor }" v-on:click="userData.investor = !userData.investor;" v-model="typeOfProfile"><div></div></div>
                                        <div class="green-chbx-lable">Investor</div>
                                    </div>
                                    

                                    <div
                                        class="line-margin fields with-line error error-massage"
                                        v-if="validationMessage"
                                    >
                                        <div class="fields-title">Error</div>
                                        <div class="fields-subtitle" v-html="validationMessage"></div>
                                    </div>
                                    <!-- <div class="recaptcha"> 
                                      <vue-recaptcha 
                                        sitekey="6LepzfwUAAAAAG2bONo_pvIWiMY1oQzjlj8hLKBP"  
                                        :loadRecaptchaScript="true" 
                                        @verify="onCaptchaVerified"
                                        ref="recaptcha"
                                        @expired="onCaptchaExpired">                      
                                      </vue-recaptcha>                                    
                                   
                                    </div> -->
                                    <div class="line-margin">
                                     <!-- <router-link to="/signin" class="go">Go to "Sign In"</router-link> -->
                                     <!-- <button v-on:click="signUp()" class="go" :class="(captcha==false)?'grey':''" :disabled="captcha==false">Sign Up</button> -->
                                     <button v-on:click="signUp()" class="go" >Sign Up</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="subtitle-1" style="font-weight: 500;color: white;">We sent you an email.<br>Please confirm to use our platform.</div>
                    </div>
                </div>
                <div class="col-lg-7 col-sm-7">
                    <div class="login-right">
                        <img src="/static/dist/images/login-img.png" class="reg-right-img">
                    </div>
                </div>
            </div>
        </div>
    </div>
    </layout-customs>
</div>
</template>
<style type="text/css">
    .grey { background: grey!important; }
    .recaptcha {
        height: 80px;
        width: 350px;
        margin-top: 30px;
    }
    .rc-anchor-pt {
        display: none;
    }
    .recaptcha iframe { width: 304px !important; }
</style>
//<script src="https://unpkg.com/vue-recaptcha@latest/dist/vue-recaptcha.min.js"></script>
<script>
import LayoutCustoms from './../../layouts/LayoutDefault.vue';
//import Header from './../Headers/index.vue'
import Api from './../../services/api'
import User from './../../services/auth'
//import VueRecaptcha from './../../../static/dist/js/vue-recaptcha.min.js';

export default {
  name: 'project',
  props: [],
  components: {
    LayoutCustoms,
    //VueRecaptcha,
  },
  data() {
    return {
      userData: {
        firstName: '',
        lastName: '',
        address: '',
        email: '',
        telephone: '',
        password: '',
        offset: new Date().getTimezoneOffset(),
        token: '',
        contactPerson: "",
        emailContact: "",
        city: "",
        stateProvince: "",
        postalZipCode: "",
        country: '',
        affiliate: false,
        investor: false,
        producer: false,
        typeOfProfile: '',
      },
      countries: [],
      validationMessage: '',
      isSuccessfulRegistration: false,
      typeOfProfile: null,
      fbSignInParams: {
        scope: 'email,user_likes',
        return_scopes: true,
      },
      googleSignInParams: {
        client_id:
          '459260954938-kpc63h85vmpjr5ribmj74u15spiko6ns.apps.googleusercontent.com',
      },
      captcha: false,
    }
  },
  methods: {
    // whenever the document is resized, re-set the 'fullHeight' variable
    handleResize(event) {
      this.setHeightImage()
    },
    generateTokenCode() {
      return URL.createObjectURL(new Blob([]))
        .slice(-36)
        .replace(/-/g, '')
    },
    signUp() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.userData.offset = new Date().getTimezoneOffset()
          this.userData.token = this.generateTokenCode()
          // this.userData.country = this.$refs.selectCountry.value
          // this.userData.typeOfProfile = 'affiliate'; // this.userData.investor ? 'investor' : this.userData.producer ? 'producer' : 'affiliate'

          

          if(this.userData.investor)
            this.userData.typeOfProfile = "investor"
          if(this.userData.affiliate)  
            if(this.userData.typeOfProfile=="")
                this.userData.typeOfProfile = "affiliate"
            else this.userData.typeOfProfile = this.userData.typeOfProfile + ", affiliate"
          if(this.userData.producer)  
            if(this.userData.typeOfProfile=="")
                this.userData.typeOfProfile = "producer"
            else this.userData.typeOfProfile = this.userData.typeOfProfile + ", producer"      

          if (this.userData.typeOfProfile == '') this.userData.typeOfProfile = 'affiliate'


          this.$http.post('/registration', this.userData).then(
            response => {
              this.isSuccessfulRegistration = true
            },
            error => {
              this.validationMessage = error.body.message
            }
          )
          return
        }
      })
    },
    signInWithGoogleSuccess(response) {
      const profile = response.getBasicProfile()
      console.log('profile google >>>>>>>>>>>>>>>>>>>>>>')
      console.log(profile)
      this.$http
        .post('/socialauth', {
          email: profile.U3,
          socialType: 'gl',
          first_name: profile.ofa,
          last_name: profile.wea,
          picture: profile.Paa,
        })
        .then(
          response => {
            User.setUserData(response.data.user)
            this.user = response.data.user.email
            this.$router.push('/dashboard')
          },
          error => {
            this.validationMessage = 'Problems with login. Try again.'
            console.error(error)
          }
        )
    },
    signInWithFacebookSuccess(response) {
      FB.api(
        '/me',
        { fields: 'id, first_name, last_name, email, name, picture' },
        dude => {
          console.log('dude')
          console.log(dude)
          console.log(dude.picture.data.url)
          this.$http
            .post('/socialauth', {
              email: dude.email,
              socialType: 'fb',
              first_name: dude.first_name,
              last_name: dude.last_name,
              picture: dude.picture.data.url,
            })
            .then(
              response => {
                User.setUserData(response.data.user)
                this.user = response.data.user.email
                this.$router.push('/dashboard')
              },
              error => {
                this.validationMessage = 'Problems with login. Try again.'
                console.error(error)
              }
            )
        }
      )
    },
    liLogin() {
       window.location.href = "/auth/linkedin"     
    },
    signInError(error) {
      this.validationMessage = 'Problems with login. Try again.'
      console.error(error)
    },
    onCaptchaVerified() {
        this.captcha = true
    },
    onCaptchaExpired() {
        console.log("notnotno")
        this.captcha = false
    },
  },
  created() {
    setTimeout(function(){ $(".rc-anchor-normal-footer").css("position", "relative")}, 5000);
    this.countries = require('./../../data/country.js')
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Account/SignUp.vue